import { NoteDetailsDialog } from './../../../dialogs/note.details/note.details.dialog';
import { MemberEventsService } from '../../../services/member.events.service';
import { NoteManagerConstructor } from '../../../managers/note.manager';
import { Subscription } from 'rxjs';
import { LicenseManager } from '../../../managers/License.manager';
import { DialogService } from '../../../services/modal-dialogs';
import { ssApiService } from '../../../services/ss-api.service';
import { Component, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { KeyValuePair } from '../../../models/KeyValuePair';

import { Note, NoteTypes } from '../../../models/domain/note';
import { NoteManager } from '../../../managers/note.manager';
import { EntityChangedArgs } from '../../../managers/manager.base';
import { GISBundleLogArray, GISBundleLogItem } from '../../../models/domain/gis.bundle.log.item';
import { GISUsageLogArray, GISUsageLogItem } from '../../../models/domain/gis.usage.log';
import { GISRefundDialog } from '../../../dialogs/gis.refund/gis.refund.dialog';
import { AddFreeGISBundleCreditsRequest } from '../../../models/ss-api/requests/add.gis.free.credits.request';
import { AddGISDialog } from '../../../dialogs/add.gis/add.gis.dialog';
import { UserRolesService } from '../../../services/user.roles.service';
import { WindowSettings } from '../../../../app/services/window-dialogs/window.settings';
import { WindowTypes, WindowActionTypes } from '../../../../app/services/window-dialogs/window.event';
import { WindowService } from '../../../../app/services/window-dialogs/window.service';
import { SortBot } from '../../../../app/helpers/sort';

@Component({
    selector: 'member-gis',
    templateUrl: './member.gis.component.html',
    styleUrls: ['./member.gis.component.css']
})

export class MemberGisComponent implements OnInit, OnDestroy {
    bundlesResultRows: number = 25;
    firstResult: number = 0;
    lastResult: number = 24;
    usageResultRows: number = 25;
    usageFirstResult: number = 0;
    usageLastResult: number = 24;

    CreditBundleSearch: String;
    CreditUsageSearch: String;

    @Input('MemberID') MemberID: number;
    @Input('IsDesigner') IsDesigner: boolean;

    @Input('IsBusy') IsBusy: boolean = false;
    @Input('Usage') Usage: GISUsageLogArray;
    @Input('Bundles') Bundles: GISBundleLogArray;
    @Output('onRefresh') onRefresh: EventEmitter<string> = new EventEmitter();

    private licenseManager: LicenseManager = new LicenseManager();
    private licenseManagerSubscription: Subscription;
    private noteChangeSubscription: Subscription;

    constructor(private api: ssApiService, private memberEvents: MemberEventsService, private sweetAlertService: SweetAlertService, private dialogService: DialogService, public roles: UserRolesService, private windowService: WindowService) { }

    sortBundlesByPurchaseDate() { this.Bundles = SortBot.SortAuto(this.Bundles, 'PurchaseDate'); }
    sortBundlesByExpireDate() { this.Bundles = SortBot.SortAuto(this.Bundles, 'ExpireDate'); }
    sortBundlesByDescription() { this.Bundles = SortBot.SortAuto(this.Bundles, 'Description'); }
    sortBundlesByCredits() { this.Bundles = SortBot.SortAuto(this.Bundles, 'BundleCredits'); }
    sortBundlesByRemaining() { this.Bundles = SortBot.SortAuto(this.Bundles, 'UsedCredits'); }
    sortBundlesByPromo() { this.Bundles = SortBot.SortAuto(this.Bundles, 'PromoID'); }

    sortUsageByPurchaseDate() { this.Usage = SortBot.SortAuto(this.Usage, 'PurchaseDate'); }

    RefreshData() {
        this.onRefresh.emit('');
    }

    ngOnInit() {
        this.licenseManagerSubscription = this.licenseManager.OnIsBusyChanged.subscribe(isBusy => {
            this.IsBusy = isBusy;
        });

        this.noteChangeSubscription = this.memberEvents.onNoteChanged.subscribe(args => this.onNoteChanged(args));
    }

    ngOnDestroy() {
        this.licenseManagerSubscription.unsubscribe();
        this.noteChangeSubscription.unsubscribe();
    }


    onNoteChanged(args: EntityChangedArgs<Note>) {

        let GISID = Note.GetNoteTypeValue(args.Original.NoteTypeList, NoteTypes.GISCredit);

        if (GISID == 0)
            return;

        // search for GIS Bundle
        let GIS = this.Bundles.find(x => x.ID == GISID);
        if (GIS != undefined) {
            // we found the bundle
            GIS.HasNotes = true;
            return;
        }

    }

    GetRemainingCredits(item: GISBundleLogItem): number {

        if (item.Refunded)
            return 0;

        return item.BundleCredits - item.UsedCredits;
    }

    GetStatus(item: GISBundleLogItem): KeyValuePair<string, string> {

        if (item.Refunded)
            return new KeyValuePair<string, string>('text-orange', 'REFUNDED'); // '<span class="text-orange">REFUNDED</span>';

        if (item.IsExpired)
            return new KeyValuePair<string, string>('text-red', 'EXPIRED');

        if (this.GetRemainingCredits(item) == 0)
            return new KeyValuePair<string, string>('text-red', 'ALL USED');

        // else
        return new KeyValuePair<string, string>('text-green', 'OK');

    }

    onLicenseClick(licenseKey: string) {

        // this.licenseManager.Load(license);
        // var windowSettings = new WindowSettings();
        // windowSettings.Height = 900;
        // windowSettings.Width = 1240;

        // this.windowService.OpenWindow<string>(WindowTypes.License, licenseKey, windowSettings);

        this.IsBusy = true;
        let manager = new LicenseManager();
        manager.OnDataLoaded.subscribe(response => {
            this.IsBusy = false;
        });
        manager.Load(licenseKey, true);
        manager.OnChangesSaveResponse.subscribe(response => {
            this.onRefresh.emit('');
        });
    }

    onNoteClick(item: GISBundleLogItem) {

        // type
        let type = new KeyValuePair<NoteTypes, number>(NoteTypes.GISCredit, item.ID);

        // constructor data
        let noteData = new NoteManagerConstructor(0, item.MemberID);
        noteData.NoteType = type;

        // note manager
        let noteManager = new NoteManager(noteData);
    }

    EditNote(item: GISBundleLogItem) {

        let type = new KeyValuePair<NoteTypes, number>(NoteTypes.GISCredit, item.ID);

        // load

        let noteData = new NoteManagerConstructor(item.ID);
        noteData.NoteType = type;

        noteData.RelationInfo = item.ID.toString();

        // let noteManager = new NoteManager(noteData);
        this.ShowNoteDialog(noteData);

    }

    AddNote(item: GISBundleLogItem) {
        // add new
        let type = new KeyValuePair<NoteTypes, number>(NoteTypes.GISCredit, item.ID);
        let noteData = new NoteManagerConstructor();
        noteData.MemberID = item.MemberID;
        noteData.NoteType = type;
        noteData.RelationInfo = item.ID.toString();
        noteData.IsAddNote = true;
        this.ShowNoteDialog(noteData);
        // let noteManager = new NoteManager(noteData);
    }

    ShowNoteDialog(noteData) {
        let options = {
            width: 1100,
            height: 650
        };

        let disposable = this.dialogService.addDialog(NoteDetailsDialog, { noteManager: new NoteManager(noteData) }, options).subscribe(response => { });
    }

    ShowNoteWindow(noteData: NoteManagerConstructor) {
        let windowSettings = new WindowSettings();
        windowSettings.Height = 900;
        windowSettings.Width = 1240;

        let result = this.windowService.OpenWindow<NoteManagerConstructor>(WindowTypes.Note, noteData, windowSettings);

        let subscription = result.onEvent.subscribe(event => {

            if (event.ActionType == WindowActionTypes.Saved) {
                this.onNoteChanged(event.Data);
            }

            if (event.ActionType == WindowActionTypes.Close)
                subscription.unsubscribe();

        });
    }

    async refundCredit(Item: GISUsageLogItem) {
        let disposable = this.dialogService.addDialog(GISRefundDialog, {
            GISUsageItem: Item
        }).subscribe(result => {
            disposable.unsubscribe();
            this.RefreshData();
        });
    }


    async addCredit(Item: GISBundleLogItem) {
        this.IsBusy = true;


        let request = new AddFreeGISBundleCreditsRequest();

        request.BundleID = Item.ID;
        request.Credits = 1;

        await this.sweetAlertService.swal(
            {
                title: 'Add Credit?',
                text: 'Are you sure you want to add a GIS credit?',
                type: 'warning',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: 'Yes!',
                cancelButtonText: 'Cancel',
                allowOutsideClick: false,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return this.api.GISAddFreeBundleCredits(request).toPromise();
                }
            }).then(async (response: any) => {

                this.sweetAlertService.swal({
                    title: 'Success',
                    text: 'GIS Credit Added',
                    type: 'success',
                    showCancelButton: false,
                    showConfirmButton: false,
                    timer: 1500
                }).then((response: any) => { }, (dismiss) => { }); // keep this line to prevent promise error;

            }, (dismiss) => { }).catch(error => {
                this.sweetAlertService.swal({
                    title: 'Error',
                    text: error.message,
                    type: 'error',
                    showCancelButton: false,
                    showConfirmButton: true,
                    confirmButtonText: 'OK',
                }).then((response: any) => { }, (dismiss) => { }); // keep this line to prevent promise error;
            });


        this.IsBusy = false;
        this.RefreshData();
    }

    swapCreditType(item) {
        this.sweetAlertService.swal({
            type: 'warning',
            title: 'Swap Credit Type?',
            text: 'Are you sure you want to swap the credit type?',
            showCancelButton: true,
            preConfirm: () => {
                return this.api.SwapGISCreditType(item.ID).toPromise();
            }
        }).then((response) => {
            if (response.Result) {
                this.sweetAlertService.swal({
                    type: 'success',
                    title: 'Credit Type Swapped',
                    showCancelButton: false,
                    showConfirmButton: false,
                    timer: 1500
                }).then(() => { this.RefreshData(); }, () => { this.RefreshData(); });
            } else {
                this.sweetAlertService.swal({
                    type: 'error',
                    title: 'Error',
                    text: response.Message
                }).then(() => { });

            }
        }, () => { });
    }


    removeCredit(item) {
        this.sweetAlertService.swal({
            type: 'warning',
            title: 'Are You Sure?',
            text: 'This cannot be undone',
            showCancelButton: true,
            preConfirm: () => {
                return this.api.DeleteGIS(item.ID).toPromise();
            }
        }).then((response) => {
            if (response.Result) {
                this.sweetAlertService.swal({
                    type: 'success',
                    title: 'GIS Deleted',
                    showCancelButton: false,
                    showConfirmButton: false,
                    timer: 1500
                }).then(() => { this.RefreshData(); }, () => { this.RefreshData(); });
            } else {
                this.sweetAlertService.swal({
                    type: 'error',
                    title: 'Error',
                    text: response.Message
                }).then(() => { });

            }
        }, () => { });
    }

    showAddGISDialog() {
        let disposable = this.dialogService.addDialog(AddGISDialog, {
            title: 'Add New',
            message: 'Confirm message',
            MemberID: this.MemberID,
        }).subscribe(response => {
            disposable.unsubscribe();
            this.RefreshData();
        }, error => {
            disposable.unsubscribe();
        });
    }

    paginateBundles(e) {
        // console.log("paginateSearch :", e);
        this.firstResult = e.page * e.rows;
        this.lastResult = this.firstResult + e.rows;
    }

    paginateUsage(e) {
        // console.log("paginateSearch :", e);
        this.usageFirstResult = e.page * e.rows;
        this.usageLastResult = this.usageFirstResult + e.rows;
    }

}
